import { Themed } from 'theme-ui'

import Icon from '../../elements/icon'
import Img from '../../elements/imgix-img/connected'
import Copy from '../copy'
import { Palette, Container, Link } from '@uswitch/ev-core/react'

const Profile = ({ name, role, company, photo, className }) => (
  <Container className={className}>
    <div
      sx={{
        display: 'flex',
        flexDirection: 'row',
        width: '100%',
      }}
    >
      <div sx={{ marginRight: 'md' }}>
        <Choose>
          <When condition={photo}>
            <Img
              entity={photo}
              width={144}
              height={144}
              sx={{ variant: 'modules.profile.img', objectFit: 'cover' }}
            />
          </When>
          <Otherwise>
            <Palette as={Icon} size='xl' sx={{ fill: 'light-3' }} px={{ fill: 'accentColor' }} />
          </Otherwise>
        </Choose>
      </div>

      <div
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
        }}
      >
        <Copy
          as='span'
          sx={{
            color: 'brand',
            lineHeight: 'sm',
            marginBottom: 'xxs',
            fontSize: 'base',
            fontWeight: 'bold',
            textDecoration: 'underline',
          }}
        >
          {name}
        </Copy>
        <Copy
          as='span'
          sx={{
            lineHeight: 'md',
            fontSize: 'sm',
            color: 'dark-2',
          }}
        >
          <If condition={role}>
            <span>{role}</span>
          </If>
          <br />
          <If condition={company}>
            <Themed.b>{company}</Themed.b>
          </If>
        </Copy>
      </div>
    </div>
  </Container>
)

const ProfileWithLinkLogic = ({ link, ...rest }) => (
  <Choose>
    <When condition={link}>
      <Link href={link}>
        <Profile {...rest} />
      </Link>
    </When>
    <Otherwise>
      <Profile {...rest} />
    </Otherwise>
  </Choose>
)

export default ProfileWithLinkLogic
